<template>
  <div v-if="analytics" class="gp-content">
    <table-tile-bar :view.sync="view" :refresh="refresh">
      <router-link class="level-item button add" :to="{ name: 'analytics.index.create' }">
        <i class="fas fa-plus"></i>
        Create Analytic
      </router-link>
      <analytics-filter-bar
        ref="filterBar"
        :filter.sync="filter"
        :digita.sync="digita"
        :categories="categories"
        :tags="tags"
        :actions="actions">
      </analytics-filter-bar>
    </table-tile-bar>
    <analytics-table
      v-if="view === 'table'"
      class="scroll-vertical full-height"
      :analytics="filteredAnalytics"
      v-on:analytic-table-tag-click="$refs.filterBar.addTagFilter($event.tag)"
      v-on:analytic-table-cat-click="$refs.filterBar.addCatFilter($event.cat)"
      v-on:analytic-table-action-click="$refs.filterBar.addActionFilter($event.action)">
    </analytics-table>
    <analytic-tiles v-else :analytics="filteredAnalytics" :type.sync="filterType">
    </analytic-tiles>
  </div>
</template>

<script>
import analyticsFilter from '@/mixins/analyticsFilter';
import analyticsMixin from '@/mixins/analytics';
import AnalyticsTable from '@/components/analytics/AnalyticsTable.vue';
import TableTileBar from '@/components/TableTileBar.vue';
import AnalyticTiles from '@/components/analytics/AnalyticTiles.vue';
import AnalyticsFilterBar from '@/components/analytics/AnalyticsFilterBar.vue';

export default {
  name: 'Analytics',
  mixins: [analyticsFilter, analyticsMixin],
  components: {
    AnalyticsTable,
    AnalyticTiles,
    TableTileBar,
    AnalyticsFilterBar,
  },
  computed: {
    view: {
      set(value) { this.$store.commit('analyticViewState/SET_VIEW', value); },
      get() { return this.$store.state.analyticViewState.view; },
    },
    filterType: {
      set(value) { this.$store.commit('analyticViewState/SET_FILTER_TYPE', value); },
      get() { return this.$store.state.analyticViewState.filterType; },
    },
    digitaFilter: {
      set(value) { this.$store.commit('analyticViewState/SET_DIGITA_FILTER', value); },
      get() { return this.$store.state.analyticViewState.digitaFilter; },
    },
  },
  watch: {
    // Watch for changes in query params and set the view to table if
    // the 'view' param is set
    // eslint-disable-next-line
    '$route.query'() {
      this.view = this.$route.query.v || 'tiles';
      if (typeof this.$route.query.fi === 'string') {
        const filterItem = this.$route.query.fi.split(':');
        if (filterItem[0] === 'tag') {
          this.$refs.filterBar.addTagFilter(filterItem[1]);
        } else if (filterItem[0] === 'category') {
          this.$refs.filterBar.addCatFilter(filterItem[1]);
        } else if (filterItem[0] === 'action') {
          this.$refs.filterBar.addActionFilter(filterItem[1]);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.full-height {
  height: 100%;
}
</style>
